import 'flickity/js/index';

import Flickity from 'flickity';

function startTimeline(timelineWrapper) {
  var timeline = timelineWrapper.querySelector(".timeline");
  let slides = timeline.querySelectorAll(".slide");
  var timelineContentWrapper = timelineWrapper.querySelector(".timeline-content-wrapper");
  var startIndex = 0;


  for (let index = 0; index < slides.length; index++) {
    const slide = slides[index];

    // Looking for related content 
    if(timelineContentWrapper){
      slide.linkedContent = timelineContentWrapper.querySelectorAll('[data-key="'+index+'"]');
      if(index === 0 && slide.linkedContent){
        slide.linkedContent.forEach((content) => {
          content.classList.remove("inactive");
      })
      }
    }
  }

  var flkty = new Flickity(timeline, {
    setGallerySize: false,
    cellAlign: 'left',  
    autoPlay: 5000,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    pageDots: false,
  });



  var currentIndex = startIndex;
  flkty.on("change", function (index) {
    var currentSlide = slides[currentIndex];
    var nextSlide = slides[index];

    if(currentSlide.linkedContent){
      currentSlide.linkedContent.forEach((content) => {
          content.classList.add("inactive");
      })
    }

    if(nextSlide.linkedContent){
      nextSlide.linkedContent.forEach((content) => {
        content.classList.remove("inactive");
    })
    }

    currentIndex = index;
  });

}

function startTimelines() {
  let timelines = document.querySelectorAll(".atk-timeline");

  for (let index = 0; index < timelines.length; index++) {
    const timelineWrapper = timelines[index];
    startTimeline(timelineWrapper);
  }
}

startTimelines();
